import { TreeSelect } from "primereact/treeselect";
import { useEffect, useState } from "react";
import ConditionalRender from "../../helpers/ConditionalRender";
import InstanceApi from "../../api/instance/InstanceApi";
import HostInstanceTypes from "../../types/HostInstanceType";
import HostApi from "../../api/host/HostApi";
import { stringFormatting } from "../../helpers/utils";
import InstanceTarget from "../../types/instance/InstanceTarget";
import HostTarget from "../../types/host/HostTarget";

function Metrics(props: {
    setAggregation: Function,
    aggregation: string,
    entityType: string,
    metricType: string,
    datasourceId: string | number,
    hostId: string | number,
    disabled: boolean,
    setStatistic: Function,
    statistic: string,
    statisticError: string,
    isDelete: boolean,
    instances: InstanceTarget[],
    hosts: HostTarget[],
    [propName: string]: any
}) {
    const {
        entityType,
        metricType,
        disabled,
        setStatistic,
        statistic,
        setAggregation,
        instances,
        hosts,
        datasourceId,
        hostId,
        isDelete,
        statisticError,
        aggregation
    } = props

    let [metricsList, setMetricsList] = useState<any[]>([]);

    const [supportedInstances, setSupportedInstances] = useState<HostInstanceTypes[]>([]);
    const [supportedHosts, setSupportedHosts] = useState<HostInstanceTypes[]>([]);


    useEffect(() => {
        const getInstanceTypes = async() => {
            const instancesSupported = await InstanceApi.getInstanceTypes()
            setSupportedInstances(instancesSupported)
        }

        const getHostsTypes = async() => {
            const hostsSupported = await HostApi.getHostTypes()
            setSupportedHosts(hostsSupported)
        }
        entityType === 'host' ? void getHostsTypes() : void getInstanceTypes()

    }, [entityType, metricType, datasourceId, hostId]);


    const getSupportedTypesList = (list: any[]) => {
        if (entityType === 'datasource') {
            if (datasourceId) {
                // @ts-ignore
                const selectedInstance: InstanceTarget = instances.find(inst => inst.id === datasourceId)
                return supportedInstances?.filter(supportedType => supportedType.type === selectedInstance?.type);
            }
            return supportedInstances?.filter(supportedType =>
                list.some(stat => stat.type === supportedType.type)
            );
        }

        if (entityType === 'host') {
            if (hostId) {
                // @ts-ignore
                const selectedHost: HostTarget = hosts.find(inst => inst.id === hostId)
                return supportedHosts.filter(supportedType => supportedType.type === selectedHost.type);
            }
            return supportedHosts.filter(supportedType =>
                list.some(stat => stat.type === supportedType.type)
            );
        }
        return []
    }

    const getDataTypes = async() => {
        let list: any[] = [];
        let metricTypes: any[] = [];
        if (entityType === 'datasource') {
            metricTypes = await InstanceApi.getInstanceStatisticTypes(metricType === 'activity')
        } else {
            metricTypes = await HostApi.getHostStatisticTypes()
        }
        const supportedMetrics = getSupportedTypesList(metricTypes)
        if (supportedMetrics.length && metricTypes.length) {
            list = supportedMetrics.map((metric: any) => {
                return {
                    "key": metric.type,
                    "label": metric.display,
                    "selectable": false,
                    children: metricTypes.filter((item: any) => item.type === metric.type).map((item: any) => ({
                        key: item.statistic,
                        label: stringFormatting(item.statistic),
                        data: item.statistic,
                        statistic: item.statistic,
                        type: item.type,
                        units: item.units,
                        cumulative: item.cumulative,
                        aggregation: item.aggregation,
                        collect: item.collect,
                        description: item.description
                    }))
                };
            })
        }
        setMetricsList(list)
    }

    useEffect(() => {
        if (supportedHosts.length || supportedHosts.length) {
            void getDataTypes();
        }
    }, [supportedInstances, supportedHosts]);

    return (
        <>
            <div className="col-xs-12 col-md-3">
                <span className="required">
                    <label htmlFor="metric" className="reminder">Metric</label>
                </span>
            </div>
            <div className="col-xs-12 col-md-6 col-lg-4 d-flex ">
                <div className="w-25 mr-10">
                    <select
                        id="aggregation"
                        autoFocus
                        className={`form-control`}
                        value={aggregation}
                        disabled={true}
                        data-lpignore={true}
                    >
                        <option value="avg">Average</option>
                        <option value="sum">Sum</option>
                    </select>
                </div>
                <div className='w-75'>
                    <TreeSelect value={statistic}
                                options={metricsList}
                                className={`form-control ${statistic && !isDelete ? 'is-valid' : statisticError === 'invalid' ? 'is-invalid' : ''}`}
                                onChange={(e) => setStatistic(e.value)}
                                onNodeSelect={(e: any) => {
                                    setAggregation(e.node.aggregation)
                                }}
                                filter
                                disabled={disabled}
                                placeholder="Select Metric"/>
                    <ConditionalRender if={statisticError && !statistic}>
                        <small className="text-danger">Metric is Required</small>
                    </ConditionalRender>
                </div>
            </div>
            <div className="w-100"/>
        </>
    )
}

export default Metrics;